  import { Injectable } from '@angular/core';
  import { HttpClient } from '@angular/common/http';
  import { Observable } from 'rxjs';
  import { environment } from '../../../environments/environment';

  export interface EmergenciaPesv {
    id?: number;
    numero_colaboradores: number;
    descripcion_equipos: string;
    simulacro: number;
    ultimo_simulacro: string;
    tipo_simulacro: number;
    estado: number;
    fecha_creacion?: string;
    fecha_modificacion?: string;
  }

  @Injectable({ providedIn: 'root' })
  export class EmergenciaPesvService {
    private apiUrl = `${environment.apiUrl}/api/emergencia_pesv`;

    constructor(private http: HttpClient) {}

    getAll(): Observable<EmergenciaPesv[]> {
      return this.http.get<EmergenciaPesv[]>(this.apiUrl);
    }

    getById(id: number): Observable<EmergenciaPesv> {
      return this.http.get<EmergenciaPesv>(`${this.apiUrl}/${id}`);
    }

    create(data: EmergenciaPesv): Observable<EmergenciaPesv> {
      return this.http.post<EmergenciaPesv>(this.apiUrl, data);
    }

    update(id: number, data: EmergenciaPesv): Observable<EmergenciaPesv> {
      return this.http.put<EmergenciaPesv>(`${this.apiUrl}/${id}`, data);
    }

    remove(id: number): Observable<any> {
      return this.http.delete(`${this.apiUrl}/${id}`);
    }

    changeEstado(id: number, estado: number): Observable<any> {
      return this.http.put(`${this.apiUrl}/${id}/estado`, { estado });
    }
  }
